import Icon from './Icon';

const Time = (props) => (
  <Icon
    {...props}
    path="M40 72.5c-17.949 0-32.5-14.551-32.5-32.5s14.551-32.5 32.5-32.5c17.949 0 32.5 14.551 32.5 32.5v0c-0.019 17.942-14.558 32.481-32.498 32.5h-0.002zM40 12.5c-15.188 0-27.5 12.312-27.5 27.5s12.312 27.5 27.5 27.5c15.188 0 27.5-12.312 27.5-27.5v0c-0.019-15.18-12.32-27.481-27.498-27.5h-0.002z M52.367 54.867c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-12.367-12.367c-0.453-0.452-0.733-1.077-0.733-1.767v-18.467c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5v0 17.433l11.633 11.633c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0c-0.447 0.453-1.068 0.733-1.755 0.733-0.004 0-0.008 0-0.012 0h0.001z"
  />
);

export default Time;
